module.exports = __webpack_public_path__ + "img/balloon-pink.2932afb0.svg";